import React from 'react';
import Paper from 'material-ui/Paper';
import { List, ListItem, ListSubHeader, ListItemContent } from 'react-toolbox/lib/list';
import { connect } from 'react-redux';
import { getTerminalTickets } from '../queries';
import * as Actions from '../actions';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import Logger from '../helpers/logger';

class MyTicketLine extends React.Component {

    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
    }

    render() {
        const { ticket, onClick = () => { } } = this.props;

        return (
            <ListItem selectable ripple={false} onClick={onClick.bind(null, ticket.id)}>
                <ListItemContent>
                    <div style={{ display: 'flex', margin: '4px' }}>
                        <span className="myListTicketNumber">{ticket.number}</span>
                        <span className="myListEntity">{(ticket.entities || []).map(x => x.name).join()}</span>
                        <span className="myListRemaining">{ticket.remaining.toFixed(2)}</span>
                    </div>
                </ListItemContent>
            </ListItem>
        );
    }
}

class MyTickets extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            searchText: ''
        };
    }

    onSearchChange = (e) => {
        this.setState({ searchText: e.target.value });
    }

    loadItems(terminalId = this.props.terminalId) {
        this.props.loadMyTicketsRequest();

        getTerminalTickets(terminalId, (items) => {
            this.props.ticketsRefreshed();

            if (items) this.props.loadMyTicketsSuccess(items);
            else this.props.loadMyTicketsFailure();
        });
    }

    componentDidMount() {
        if (
            this.props.terminalId &&
            !this.props.ticket &&
            (this.props.ticketsNeedsRefresh || !this.props.items)
        ) {
            this.loadItems(this.props.terminalId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.ticketsNeedsRefresh && !nextProps.isFetching) {
            if (this.props.ticket) {
                this.props.ticketsRefreshed();
                return;
            }

            Logger.log('Reload 3', nextProps);
            this.loadItems(nextProps.terminalId);

        } else if (nextProps.terminalId && this.props.ticket && nextProps.ticket == undefined) {
            Logger.log('Reload 1', nextProps.ticket, this.props.ticket);
            this.loadItems(nextProps.terminalId);

        } else if (nextProps.terminalId && nextProps.terminalId !== this.props.terminalId) {
            Logger.log('Reload 2', nextProps.terminalId, this.props.terminalId);
            this.loadItems(nextProps.terminalId);
        }
    }

    getFilteredItems = () => {
        const searchText = (this.state.searchText || '').toLocaleLowerCase('tr-TR');

        return (this.props.items || [])
            .filter(x => {
                if (!searchText) return true;

                const ticketNumber = (x.number || '').toLocaleLowerCase('tr-TR');
                const entityText = (x.entities || [])
                    .map(e => e.name || '')
                    .join(' ')
                    .toLocaleLowerCase('tr-TR');

                return ticketNumber.indexOf(searchText) > -1 ||
                    entityText.indexOf(searchText) > -1;
            })
            .sort((x, y) => new Date(y.lastOrderDate) - new Date(x.lastOrderDate));
    }

    onTicketClickInternal = (ticketId) => {
        this.setState({
            searchText: ''
        });

        if (this.props.onClick) {
            this.props.onClick(ticketId);
        }
    }

    render() {
        if (this.props.ticket && !this.props.ticketsNeedsRefresh) return null;
        if (!this.props.items) return (<div>Loading...</div>);

        const filteredItems = this.getFilteredItems();

        return (
            <Paper className="myTickets" style={{ borderRadius: '0' }}>
                <List>
                    <div className="myTicketsSearchWrapper">

                        <input
                            type="text"
                            placeholder="Masa / adisyon ara..."
                            value={this.state.searchText}
                            onChange={this.onSearchChange}
                            className="myTicketsSearchInput"
                        />

                        {this.state.searchText &&
                            <button
                                className="myTicketsSearchClear"
                                onClick={() => this.setState({ searchText: '' })}
                            >
                                ×
                            </button>
                        }

                    </div>

                    {filteredItems.map((x) =>
                        <MyTicketLine
                            key={x.id}
                            ticket={x}
                            onClick={this.onTicketClickInternal}
                        />
                    )}
                </List>
            </Paper>
        );
    }
}

const mapStateToProps = state => ({
    isFetching: state.myTickets.get('isFetching'),
    items: state.myTickets.get('items'),
    ticketsNeedsRefresh: state.myTickets.get('ticketsNeedsRefresh'),
    terminalId: state.app.get('terminalId')
});

const mapDispatchToProps = ({
    loadMyTicketsRequest: Actions.loadMyTicketsRequest,
    loadMyTicketsSuccess: Actions.loadMyTicketsSuccess,
    loadMyTicketsFailure: Actions.loadMyTicketsFailure,
    ticketsRefreshed: Actions.ticketsRefreshed
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MyTickets);



// WEBPACK FOOTER //
// ./app/components/MyTickets.jsx